// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as CopyFDefault } from '../../../assets/icons/default/general/copy-f.svg?react';
import { ReactComponent as CopyFSolid } from '../../../assets/icons/solid/general/COPY-F.svg?react';
import { createIcons } from '../../Icon';
const CopyFIcon = /* @__PURE__ */ createIcons('CopyF', {
    default: CopyFDefault,
    solid: CopyFSolid
});
CopyFIcon.supportedTypes = ['default', 'solid'];
CopyFIcon.category = 'general';
export default CopyFIcon;
